
import { View } from 'client-website-ts-library/plugins';
import { Office, Profile } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { Component, Mixins } from 'vue-property-decorator';
import { ProfileFilter } from 'client-website-ts-library/filters';

import ProfileCards from '@/components/ProfileCards.vue';
import ListingSearch from '@/components/ListingSearch.vue';

@Component({
  components: {
    ListingSearch,
    ProfileCards,
  },
})
export default class About extends Mixins(View) {
  private office: Office | null = null;

  private profiles: Profile[] = [];

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;
    });

    API.Profiles.Search(new ProfileFilter()).then((profiles) => {
      this.profiles = profiles;
    });
  }
}
